// extracted by mini-css-extract-plugin
export var body = "styles-module--body--XF98R";
export var caption = "styles-module--caption--Df8WW";
export var flexContainer = "styles-module--flexContainer--npOLk";
export var flexItems = "styles-module--flexItems--yMmWN";
export var patient = "styles-module--patient--g8I5H";
export var visit = "styles-module--visit--8WVvC";